export default __webpack_public_path__ + "static/media/3 User 2.ff59163a.svg";